import { memo } from 'react';
import { Link } from 'react-router-dom';
import classNames from 'classnames/bind';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faCheck } from '@fortawesome/pro-regular-svg-icons/faCheck';

import ButtonComponent from '../../../../Buttons/ButtonComponent';

import withComponentName from '../../../../../decorators/withComponentName';

import productsAndDevices from '../../../../../data/homepage/productsAndDevices';

import topImgBig from '../../../../../assets/homepage/pic-1-screen.svg';
import topImgMd from '../../../../../assets/homepage/pic-1-screen-2.svg';
import topImgMobile from '../../../../../assets/homepage/greeting-mobile.svg';

import Styles from '../styles.module.scss';

const cx = classNames.bind(Styles);

export const GreetingSection = ({
  sendHomePageActions,
  isWatchlists,
  isGuestWatchlists,
}) => (
  <div className={Styles.greeting_wrapper}>
    <div className={cx('greeting_wrapper_inner')}>
      <div className={Styles.description}>
        <div className={Styles['description-text']}>
          <h1>
            Power Your Decisions
          </h1>
          <p>
            In Financial Markets and in Business
            {' '}
            <br />
            <span>
              by voice or text in
              {' '}
              <a
                href="https://www.cityfalcon.ai/features/language-coverage"
              >
                50+ languages
              </a>
            </span>
          </p>
          <ul>
            <li>
              <FontAwesomeIcon icon={faCheck} />
              <span>any asset class</span>
            </li>
            <li>
              <FontAwesomeIcon icon={faCheck} />
              <span>any sector</span>
            </li>
            <li>
              <FontAwesomeIcon icon={faCheck} />
              <span>any financial topic</span>
            </li>
            <li>
              <FontAwesomeIcon icon={faCheck} />
              <span>any location</span>
            </li>
          </ul>
        </div>
        <div className={Styles.greeting_buttons}>
          <div className={Styles.greeting_buttons_started}>
            <ButtonComponent
              withoutReload
              value="Get Started for Free"
              checkEvent={() => sendHomePageActions('Get started (main)')}
              longer
              green
              with_margin
              path="/news/onboarding/watchlist"
            />
          </div>
          {Boolean(isWatchlists || isGuestWatchlists) && (
            <div className={Styles.greeting_buttons_access}>
              <ButtonComponent
                withoutReload
                checkEvent={() => sendHomePageActions('Access your watchlists')}
                value="Access Your Watchlists"
                longer
                path="/watchlists"
              />
            </div>
          )}
        </div>
        <div className={Styles.greeting_available}>
          <h6>Also available on:</h6>
          <div className={Styles.icons_row}>
            {productsAndDevices.map((item) => (
              item.withRedirect ? (
                <a
                  key={item.id}
                  href={item.path}
                  target={item.newTab ? '_blank' : '_self'}
                  rel="noreferrer"
                  className={Styles.icon_wrapper}
                >
                  <span
                    style={{ width: `${item.width}px`, height: `${item.height}px` }}
                    className={cx('icon', item.class)}
                  />
                  <span className={Styles.name}>{item.name}</span>
                </a>
              ) : (
                <Link
                  key={item.id}
                  to={item.path}
                  className={Styles.icon_wrapper}
                >
                  <span
                    style={{ width: `${item.width}px`, height: `${item.height}px` }}
                    className={cx('icon', item.class)}
                  />
                  <span className={Styles.name}>{item.name}</span>
                </Link>
              )
            ))}
          </div>
        </div>
      </div>
      <div className={Styles['top-image-wrapper']}>
        <picture>
          <source media="(max-width: 1160px)" srcSet={topImgMd} />
          <source media="(max-width: 767px)" srcSet={topImgMobile} />
          <img src={topImgBig} alt="" loading="lazy" />
        </picture>
      </div>
    </div>
  </div>
);

export default withComponentName(memo(GreetingSection));
